<template>
  <div class="h-full">
    
  </div>
</template>
<script>
  import Vue from 'vue';
  export default Vue.extend({

  });
</script>


// WEBPACK FOOTER //
// ReportDiscussionTab.vue?4e9d0a42